import { useState } from 'react'

import Button from './Button'
import Dialog from './Dialog'
import GridCircularProgress from './GridCircularProgress'
import { useDownloadFile } from '../hooks/download-functions'
import { formatLog } from '../hooks/utils-functions'

const ButtonDownload = ({ algorithm, type }) => {
  const { downloadFile } = useDownloadFile()

  const [loading, setLoading] = useState()
  const [openDialog, setOpenDialog] = useState()
  const [fileContent, setFileContent] = useState()

  const isCsv = type === 'CSV'
  const isTxt = type === 'TXT'
  const isPdf = type === 'PDF'
  const isExcel = type === 'XLSX'

  const is02 = algorithm === '02_GenerateGironi'
  const is03 = algorithm === '03_GenerateCalendari'
  const is21 = algorithm === '21_InformativaArbitri'

  return (
    <center>
      <Button
        disabled={loading}
        excel={isExcel}
        pdf={isPdf}
        txt={isTxt}
        onClick={async () => {
          setLoading(true)
          const txt = await downloadFile(algorithm, type, isTxt, isTxt, isTxt)
          setLoading()
          if (txt && isTxt) {
            setFileContent(formatLog(txt))
            setOpenDialog(true)
          }
        }}
      >
        {(loading && <GridCircularProgress color='inherit' size='1rem' />) ||
          (isTxt && 'Apri LOG') ||
          (isCsv && 'Scarica CSV') ||
          (isPdf &&
            ((is02 && 'Scarica PDF / categoria') ||
              (is03 && 'Scarica PDF / girone') ||
              (is21 && 'Scarica informativa'))) ||
          (isExcel && is03 && 'Scarica XLSX / girone')}
      </Button>
      <Dialog
        open={openDialog}
        handleClose={() => setOpenDialog()}
        title={`LOG ${algorithm}`}
        dialogLog={fileContent}
        textConfirm='Scarica'
        triggerFunction={() => downloadFile(algorithm, type)}
      />
    </center>
  )
}

export default ButtonDownload
